export default "__VITE_ASSET__BqoaXbzF__"